import { createRoute } from "@tanstack/react-router";

import { shellRoute } from "@platform/shell.route";
import { requirePlatformAdmin } from "@platform/auth/guards";
import { CommunicationsPage } from "./communications.page";

export const adminCommunicationRoute = createRoute({
	getParentRoute: () => shellRoute,
	path: "/admin/communication",
	beforeLoad: ({ context }) => requirePlatformAdmin(context.queryClient),
	component: CommunicationsPage,
});
